(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["koira-brand-filter"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('input', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('[data-koira-brand-search]')) return;

    const root = input.closest('.koira-brands');
    if (!root) return;

    const query = input.value.trim().toLowerCase();
    let visible = 0;

    root.querySelectorAll('[data-brand-name]').forEach((item) => {
      const match = query === '' || item.dataset.brandName.includes(query);
      item.hidden = !match;
      if (match) visible++;
    });

    const empty = root.querySelector('[data-koira-brand-empty]');
    if (empty) empty.hidden = visible > 0;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koira-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('koira-reviews-carousel')) {
    customElements.define(
      'koira-reviews-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.koira-reviews__list');
          this.items = [...this.querySelectorAll('.koira-reviews__card')];
          this.dots = [...this.querySelectorAll('.koira-reviews__dot')];
          this.arrows = [...this.querySelectorAll('.koira-reviews__arrow')];
          if (!this.track || !this.items.length) return;
          this.index = 0;

          this.arrows.forEach((btn) =>
            btn.addEventListener('click', () => this.goTo(this.index + Number(btn.dataset.dir)))
          );
          this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.index))));
          this.track.addEventListener('scroll', () => {
            clearTimeout(this.settle);
            this.settle = setTimeout(() => {
              this.index = this.current();
              this.update();
            }, 120);
          }, { passive: true });
          window.addEventListener('resize', () => this.update());
          this.update();
        }

        maxIndex() {
          const maxScroll = this.track.scrollWidth - this.track.clientWidth;
          const first = this.items[0].offsetLeft;
          const i = this.items.findIndex((item) => item.offsetLeft - first >= maxScroll - 4);
          return i === -1 ? this.items.length - 1 : i;
        }

        current() {
          const first = this.items[0].offsetLeft;
          const left = this.track.scrollLeft;
          if (left >= this.track.scrollWidth - this.track.clientWidth - 4) return this.maxIndex();
          let best = 0;
          let bestDist = Infinity;
          this.items.forEach((item, i) => {
            const dist = Math.abs(item.offsetLeft - first - left);
            if (dist < bestDist) {
              bestDist = dist;
              best = i;
            }
          });
          return best;
        }

        goTo(index) {
          const i = Math.max(0, Math.min(this.maxIndex(), index));
          this.index = i;
          this.track.scrollTo({ left: this.items[i].offsetLeft - this.items[0].offsetLeft, behavior: 'smooth' });
          this.update();
        }

        update() {
          const max = this.maxIndex();
          if (this.index > max) this.index = max;
          this.dots.forEach((dot, d) => {
            dot.hidden = d > max;
            dot.setAttribute('aria-current', d === this.index ? 'true' : 'false');
          });
          if (this.arrows[0]) this.arrows[0].disabled = this.index <= 0;
          if (this.arrows[1]) this.arrows[1].disabled = this.index >= max;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koira-routine"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('koira-routine-carousel')) {
    customElements.define(
      'koira-routine-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.koira-routine__steps');
          this.items = [...this.querySelectorAll('.koira-routine__step')];
          this.dots = [...this.querySelectorAll('.koira-routine__dot')];
          this.arrows = [...this.querySelectorAll('.koira-routine__arrow')];
          if (!this.track || !this.items.length) return;

          this.index = 0;
          this.arrows.forEach((btn) =>
            btn.addEventListener('click', () => this.goTo(this.index + Number(btn.dataset.dir)))
          );
          this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.index))));
          this.track.addEventListener('scroll', () => {
            clearTimeout(this.settle);
            this.settle = setTimeout(() => {
              this.index = this.current();
              this.update();
            }, 120);
          }, { passive: true });
          this.update();
        }

        current() {
          if (this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4) {
            return this.index >= this.items.length - 2 ? this.index : this.items.length - 1;
          }
          const start = this.track.getBoundingClientRect().left;
          let best = 0;
          let bestDist = Infinity;
          this.items.forEach((item, i) => {
            const dist = Math.abs(item.getBoundingClientRect().left - start - 16);
            if (dist < bestDist) {
              bestDist = dist;
              best = i;
            }
          });
          return best;
        }

        goTo(index) {
          const i = Math.max(0, Math.min(this.items.length - 1, index));
          const item = this.items[i];
          this.index = i;
          this.update();
          this.track.scrollTo({ left: item.offsetLeft - this.items[0].offsetLeft, behavior: 'smooth' });
        }

        update() {
          const last = this.items.length - 1;
          this.dots.forEach((dot, d) => dot.setAttribute('aria-current', d === this.index ? 'true' : 'false'));
          if (this.arrows[0]) this.arrows[0].disabled = this.index <= 0;
          if (this.arrows[1]) this.arrows[1].disabled = this.index >= last;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
